// FNP-79: read selection sets include the FNP-76 programmatic-provisioning
// fields (provisioningExecutionId, progress, stageDomains, etc.) so the EditPage can
// render the live-progress section and the Profile can show the provisioned
// state without a second round-trip.

const APPLICATION_FIELDS = `
    id
    name
    description
    url
    logoUrl
    applicationCategory
    applicationStatus
    created
    updated
    displayName
    businessDomain
    applicationType
    parentDomainName
    subdomain
    deploymentAccountGroupId
    sourceRepositoryName
    infraRepositoryName
    sourcePipelineId
    infraPipelineId
    provisioningExecutionId
    stepFunctionsExecutionArn
    statusReason
    statusUpdatedAt
    stageDomains { dev test prod }
    stageHostedZoneIds { dev test prod }
    stageCertificateArns { dev test prod }
    infraStackNames { dev test prod }
    deploymentBucketNames { dev test prod }
    progress { currentStep completedSteps failedStep }
    rollbackSummary {
        rolledBackSteps
        rollbackErrors { step error }
    }
    tags { key value }
`;

// FNP-913: token pagination. The API has always supported it
// (`listApplications(filter, limit, nextToken): ApplicationConnection` with
// `nextToken: String` — console-api applications.graphql:103-106, :209); this
// query simply never asked for it, so the whole catalog came back as one
// unpaginated page and `nextToken` was discarded by the service.
//
// Selecting nextToken is what makes useInfiniteQuery possible — without it
// getNextPageParam has nothing to return and the list can never page.
export const listApplications = `
   query listApplications($filter: ApplicationsFilterInput, $limit: Int, $nextToken: String) {
       listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              ${APPLICATION_FIELDS}
           }
           nextToken
       }
   }
`;

export const getApplication = `
   query getApplication($id:ID!) {
       getApplication(id:$id) {
           ${APPLICATION_FIELDS}
       }
}`;
